module.exports = __webpack_public_path__ + "static/media/frame.896c676d.png";